<template>
  <Content :button-create-show="true">
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
        :method-delete-row="methods.deleteRow"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";

import { getStores, deleteStore as deleteRow } from "@/api/stores";
import { getRegions } from "@/api/regions";

const columns = [
  {
    prop: "id",
    label: "ID",
    sortable: false,
  },
  {
    prop: "city",
    label: "Город",
  },
  {
    prop: "address",
    label: "Адрес",
  },
  {
    prop: "region",
    label: "Регион",
    sortable: false,
    type: "info",
  },
  // {
  //   prop: "comments",
  //   label: "Примечание",
  //   sortable: false,
  // },
  // {
  //   prop: "worktime",
  //   label: "График работы",
  //   sortable: false,
  //   type: "worktime",
  // },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: {
        sortable: "custom",
        controls: true,
        id: "id",
        edit: true,
        delete_row: {
          buttonName: "Удалить",
        },
        search_list: [
          {
            name: "city",
            label: "Город",
            strong: true,
          },
          {
            name: "region.id",
            label: "Регион",
            values: [],
            strong: true,
          },
          {
            name: "pos_id",
            label: "POS ID",
            strong: true,
          },
        ],
      },
      columns: columns,
      methods: {
        async fetchData(params) {
          const data = await getStores(params);
          return data.stores;
        },
        deleteRow,
      },
    };
  },
  async created() {
    const { regions } = await getRegions();
    const regionSearch = this.columnsOptions.search_list.find(
      (s) => s.name === "region.id"
    );
    regionSearch.values = regions.map((r) => ({
      label: r.name,
      code: r.id,
    }));
  },
};
</script>
